export type AuthActionMode =
  | 'recoverEmail'
  | 'resetPassword'
  | 'revertSecondFactorAddition'
  | 'verifyAndChangeEmail'
  | 'verifyEmail';

export type EmailVerificationFlow = 'signup' | 'verifiedAccount';

export type AuthActionSuccessAction = {
  path: '/onboarding' | '/settings' | '/sign-in' | '/verify-account';
  title: string;
};

export function authActionUrlWithEmailVerificationFlow(
  baseUrl: string,
  flow: EmailVerificationFlow,
) {
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}flow=${encodeURIComponent(flow)}`;
}

export function parseEmailVerificationFlow(
  value: string | null | undefined,
): EmailVerificationFlow | null {
  if (value === 'signup' || value === 'verifiedAccount') {
    return value;
  }

  return null;
}

export function emailVerificationFlowFromActionParams({
  continueUrl,
  flow,
}: {
  continueUrl?: string | null;
  flow?: string | null;
}): EmailVerificationFlow | null {
  const directFlow = parseEmailVerificationFlow(flow);

  if (directFlow) {
    return directFlow;
  }

  if (!continueUrl) {
    return null;
  }

  try {
    const parsedUrl = new URL(continueUrl, 'https://frienzzi.com');
    return parseEmailVerificationFlow(parsedUrl.searchParams.get('flow'));
  } catch {
    return null;
  }
}

export function getAuthActionSuccessAction({
  emailVerificationFlow,
  hasProfile,
  mode,
}: {
  emailVerificationFlow?: EmailVerificationFlow | null;
  hasProfile?: boolean;
  mode: AuthActionMode | undefined;
}): AuthActionSuccessAction {
  if (mode === 'verifyEmail') {
    if (
      emailVerificationFlow === 'verifiedAccount' ||
      (!emailVerificationFlow && hasProfile)
    ) {
      return {
        path: '/verify-account',
        title: 'Continue verification',
      };
    }

    return {
      path: '/onboarding',
      title: 'Finish your account',
    };
  }

  if (mode === 'verifyAndChangeEmail') {
    if (emailVerificationFlow === 'signup' || !hasProfile) {
      return {
        path: '/onboarding',
        title: 'Continue',
      };
    }

    return {
      path: '/settings',
      title: 'Continue',
    };
  }

  return {
    path: '/sign-in',
    title: 'Go to sign in',
  };
}
